import md5 from "js-md5";
import config from "@/config/index";
/**
 * 手机号码加*号
 * @param {string} phone 13872717211 => 138****888
 */
export const parsePhoneToStar = (phone) => {
    if (phone) return phone.replace(/^(\d{3})\d{4}(\d+)/, "$1****$2");
    else phone;
};

/**
 *
 * @param {String} code 转化车牌号 闽E88888 => 闽E 88888
 */
export const parseCarCode = (code) => {
    if (code) {
        return code.slice(0, 2) + " " + code.slice(2);
    } else {
        return "";
    }
};
/**
 * 获取时间是周几
 * @param {string} date 2020-03-21 10:02:10
 */
export const parseDateToWeek = (date) => {
    return "周" + "日一二三四五六".charAt(new Date(date).getDay());
};

/**
 * 短信参数转化
 */
export const parseSmsKey = (phone) => {
    // var key = 'uyuYT235690ct129ppytf';
    var key = config.accessKey;

    var firstKey = key.substring(0, 1);
    var endKey = key.substring(key.length - 1, key.length);
    var subKey = key.substring(1, key.length - 1);

    var firstPhone = phone.substr(0, 1);
    var endPhone = phone.substring(phone.length - 1, phone.length);
    var subPhone = phone.substring(1, phone.length - 1);

    var str = endPhone;
    str += subKey;
    str += firstPhone;
    str += "-";
    str += endKey;
    str += subPhone;
    str += firstKey;

    var md5Str = md5(str);

    return md5Str.toUpperCase();
};
